import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Provider as ReakitProvider } from 'reakit/Provider';
import { AriaLiveProvider } from '@ally/use-aria-live';
import { styledTheme } from '../tools/theme';
var MetronomeProvider = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? styledTheme : _b, children = _a.children;
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(ReakitProvider, null,
            React.createElement(AriaLiveProvider, null, children))));
};
export { MetronomeProvider };
//# sourceMappingURL=MetronomeProvider.js.map